import { useState } from "react";
import products from "../data/products";
import ProductCard from "../components/ProductCard";
import { motion, AnimatePresence } from "framer-motion";

export default function Products() {
  const [category, setCategory] = useState("all");

  const filteredProducts =
    category === "all"
      ? products
      : products.filter((p) => p.category === category);

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container"></div>
      </section>

      {/* Category Toggle */}
      <section className="category-toggle">
        <div className="container">

          <div className="toggle-buttons">
            {["all", "cosmetics", "skin-care", "herbals", "nutraceuticals"].map((cat) => (
              <button
                key={cat}
                className={`toggle-btn ${category === cat ? "active" : ""}`}
                onClick={() => setCategory(cat)}
              >
                {cat === "all"
                  ? "All Products"
                  : cat.replace("-", " ").replace(/\b\w/g, l => l.toUpperCase())}
              </button>
            ))}
          </div>

          {/* Product Grid */}
          <motion.div layout className="products-grid">
            <AnimatePresence mode="popLayout">
              {filteredProducts.map((item) => (
                <motion.div
                  key={item.id}
                  layout
                  initial={{ opacity: 0, y: 30, scale: 0.95 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: 20, scale: 0.95 }}
                  transition={{
                    duration: 0.35,
                    ease: "easeOut",
                  }}
                >
                  <ProductCard
                    image={item.image}
                    category={item.category}
                    name={item.name}
                    description={item.description}
                    slug={item.slug}
                  />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

        </div>
      </section>
    </>
  );
}
